/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import receiveLocationGroups from './receive-location-websites';
import * as actions from 'state/action-types';

export default (locationWebsiteId = null) => (dispatch) => {
    return cecSdk
        .locationWebsite(locationWebsiteId)
        .remove()
        .then(() => {
            dispatch({ type: actions.DELETE_LOCATION_WEBSITE_SUCCESS, payload: { locationWebsiteId } });
        });
};
